import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { FineOrderModel } from 'src/app/shared/interfaces/fineOrderModel';
import { FineService } from 'src/app/shared/services/fine.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { TranslateDirective } from 'src/app/shared/translate.directive';

@Component({
  selector: 'app-confirm-payment-fines',
  standalone: true,
  imports: [TranslateDirective, CommonModule, FormsModule],
  templateUrl: './confirm-payment-fines.component.html',
  styleUrl: './confirm-payment-fines.component.less'
})
export class ConfirmPaymentFinesComponent implements OnInit {

  fine: any;
  hasErrors = false;
  errorsMessages: any;
  fineOrderModel: FineOrderModel = {
    fineId: null,
    zoneName: '',
    vehicleRegistration: '',
    accountId: '',
    status: '',
    bankReference: '',
    failedPayments: 0,
    amount: 0,
    amountVat: 0,
    instanceId: '',
    token: '',
    activateTime: '',
    activateTimeText: ''
  };
  isLogged = false;
  instanceId: any = '';
  constructor(private fineService: FineService, private router: Router, public myLoaderService: LoaderService, public loginService: LoginService) {

  }

  ngOnInit() {
    this.fine = history.state.data;

    this.loginService.contextChange.subscribe(() => {
      this.isLogged = this.loginService.isAuthenticated();
    });
    this.isLogged = this.loginService.isAuthenticated();

    if (!this.isLogged) {

      let instanceId = localStorage.getItem('instanceId');

      if (!instanceId) {
        instanceId = crypto.randomUUID();
        localStorage.setItem('instanceId', instanceId);
      }

      this.instanceId = instanceId;
    }
  }

  goToFines() {
    this.router.navigate(['/fines']);
  }
  pay() {

    this.fineOrderModel.fineId = this.fine.FineId;
    this.fineOrderModel.status = this.fine.Status;
    this.fineOrderModel.amount = this.fine.Amount;
    this.fineOrderModel.amountVat = this.fine.AmountVAT;
    this.fineOrderModel.vehicleRegistration = this.fine.CarNo;
    this.fineOrderModel.zoneName = this.fine.AssetOwnerUniqueID;
    this.fineOrderModel.accountId = this.fine.AccountID;
    this.fineOrderModel.activateTime = this.fine.ActivateTime;
    this.fineOrderModel.activateTimeText = this.fine.ActivateTimeText;
    this.fineOrderModel.bankReference = this.fine.BankReference;
    this.fineOrderModel.isBusiness = false;
    if (!this.isLogged) {
      this.fineOrderModel.instanceId = this.instanceId;
    }

    this.fineService.payFine(this.fineOrderModel).subscribe((res: any) => {
      window.location.href = res.RedirectUrl;
    },

      error => {
        this.hasErrors = true;
        this.errorsMessages = error.error.errors[0].Errors[0];
      });
  }
}
